<template>
  <AppAsideDialog v-bind="{ isOpened }" @close="closeAside">
    <IntlMsg
      v-bind="{ k: 'auth.reset.title', tag: 'h4' }"
      class="mb-7 text-xl font-semibold leading-7 sm:mb-10 sm:text-3xl"
    />

    <template v-if="view === 'form'">
      <ResetPasswordForm
        v-bind="{ isVisible: isOpened }"
        class="mb-7 flex flex-col items-start sm:mb-10"
        @success="view = 'success'"
      />

      <SocialAuth
        class="border-y-2 border-gray-100 pb-6 pt-4 sm:pb-7 sm:pt-5"
      />

      <div class="mt-10">
        <IntlMsg
          v-bind="{ k: 'auth.login.not-signed-up' }"
          class="mb-4 block text-lg font-semibold leading-6 sm:mb-6 sm:text-xl"
        />

        <div class="flex items-start justify-start">
          <button
            class="c-btn c-btn--gray max-w-full text-lg font-semibold"
            @click.prevent="
              () => {
                closeAside()
                bus.emit('app::show-signup-aside')
              }
            "
          >
            <IntlMsg
              v-bind="{ k: 'auth.login.go-to-sign-up' }"
              class="truncate"
            />
          </button>
        </div>
      </div>
    </template>
    <div v-else>
      <i18n-t
        keypath="auth.reset.success-message"
        tag="p"
        scope="global"
        class="mx-auto mt-2 max-w-sm leading-normal"
      >
        <AppLink
          v-bind="{ to: { name: 'ContactsPage', hash: '#contact-form' } }"
          class="text-blue-600 underline"
          @click="closeAside"
        >
          <IntlMsg v-bind="{ k: 'auth.reset.success-contacts' }" />
        </AppLink>
      </i18n-t>
    </div>
  </AppAsideDialog>
</template>

<script lang="ts" setup>
import { onUnmounted, ref } from 'vue'

import { bus, IntlMsg } from '/@shared/app'
import { AppAsideDialog, AppLink } from '/@app'
import { ResetPasswordForm, SocialAuth } from '/@auth'

const isOpened = ref(false)

function closeAside() {
  isOpened.value = false
}
function openAside() {
  isOpened.value = true
}

bus.on('app::show-restore-password-aside', openAside)
onUnmounted(() => bus.off('app::show-restore-password-aside', openAside))

const view = ref<'form' | 'success'>('form')
</script>
